module.exports = __webpack_public_path__ + "img/normal-5f1a028d.png";